module.exports = __webpack_public_path__ + "img/gi.c2f37bd.svg";